module.exports = __webpack_public_path__ + "img/31.90006525.jpg";